export default __webpack_public_path__ + "static/media/icon-1of1.eca256b0.svg";